const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBCarTraffic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M 16.054688 12.5 C 15.195313 12.5 14.5 11.828125 14.5 11 C 14.5 10.171875 15.195313 9.5 16.054688 9.5 L 37.949219 9.5 C 38.804688 9.5 39.5 10.171875 39.5 11 C 39.5 11.828125 38.804688 12.5 37.949219 12.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 37.945313 10 C 38.527344 10 39 10.449219 39 11 C 39 11.550781 38.527344 12 37.945313 12 L 16.054688 12 C 15.472656 12 15 11.550781 15 11 C 15 10.449219 15.472656 10 16.054688 10 L 37.945313 10 M 37.945313 9 L 16.054688 9 C 14.917969 9 14 9.894531 14 11 C 14 12.105469 14.917969 13 16.054688 13 L 37.949219 13 C 39.082031 13 40 12.105469 40 11 C 40 9.894531 39.082031 9 37.945313 9 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M 35 22.5 C 34.726563 22.5 34.5 22.277344 34.5 22 L 34.5 19.5 L 37.5 19.5 L 37.5 22 C 37.5 22.277344 37.273438 22.5 37 22.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 37 20 L 37 22 L 35 22 L 35 20 L 37 20 M 38 19 L 34 19 L 34 22 C 34 22.550781 34.449219 23 35 23 L 37 23 C 37.550781 23 38 22.550781 38 22 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M 16.5 19.5 L 16.5 13.320313 L 17.457031 11.203125 L 19.480469 4.136719 C 19.757813 3.304688 20.984375 2.5 22 2.5 L 32 2.5 C 33.015625 2.5 34.242188 3.304688 34.523438 4.15625 L 36.519531 11.136719 L 37.5 13.320313 L 37.5 19.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 32 3 C 32.800781 3 33.835938 3.664063 34.039063 4.273438 L 36.039063 11.273438 L 36.058594 11.34375 L 36.089844 11.410156 L 37 13.429688 L 37 19 L 17 19 L 17 13.429688 L 17.910156 11.410156 L 17.941406 11.34375 L 17.960938 11.273438 L 19.949219 4.316406 C 20.164063 3.664063 21.199219 3 22 3 L 32 3 M 32 2 L 22 2 C 20.832031 2 19.367188 2.890625 19 4 L 17 11 L 16 13.214844 L 16 20 L 38 20 L 38 13.214844 L 37 11 L 35 4 C 34.632813 2.890625 33.167969 2 32 2 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 36 14.5 C 36 15.328125 35.328125 16 34.5 16 C 33.671875 16 33 15.328125 33 14.5 C 33 13.671875 33.671875 13 34.5 13 C 35.328125 13 36 13.671875 36 14.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF0FE"
    },
    d: "M 17.949219 9.5 L 19.480469 4.136719 C 19.792969 3.195313 20.675781 2.5 21.574219 2.5 L 32.425781 2.5 C 33.320313 2.5 34.207031 3.195313 34.527344 4.15625 L 36.050781 9.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 32.425781 3 C 33.101563 3 33.800781 3.566406 34.039063 4.273438 L 35.390625 9 L 18.609375 9 L 19.949219 4.316406 C 20.199219 3.566406 20.898438 3 21.574219 3 L 32.425781 3 M 32.425781 2 L 21.574219 2 C 20.40625 2 19.367188 2.890625 19 4 L 17.285156 10 L 36.714844 10 L 35 4 C 34.632813 2.890625 33.59375 2 32.425781 2 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M 15.976563 10 L 38 10 L 38 12 L 15.976563 12 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 21.695313 19.5 L 23.1875 15.089844 C 23.304688 14.734375 23.632813 14.5 24 14.5 L 30 14.5 C 30.367188 14.5 30.695313 14.734375 30.8125 15.085938 L 32.304688 19.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 30 15 C 30.152344 15 30.289063 15.097656 30.339844 15.246094 L 31.605469 19 L 22.394531 19 L 23.660156 15.242188 C 23.710938 15.097656 23.847656 15 24 15 L 30 15 M 30 14 L 24 14 C 23.414063 14 22.898438 14.375 22.710938 14.929688 L 21 20 L 33 20 L 31.289063 14.929688 C 31.101563 14.375 30.585938 14 30 14 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 2.054688 21.5 C 1.195313 21.5 0.5 20.828125 0.5 20 C 0.5 19.171875 1.195313 18.5 2.054688 18.5 L 23.949219 18.5 C 24.804688 18.5 25.5 19.171875 25.5 20 C 25.5 20.828125 24.804688 21.5 23.949219 21.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 23.945313 19 C 24.527344 19 25 19.449219 25 20 C 25 20.550781 24.527344 21 23.945313 21 L 2.054688 21 C 1.472656 21 1 20.550781 1 20 C 1 19.449219 1.472656 19 2.054688 19 L 23.945313 19 M 23.945313 18 L 2.054688 18 C 0.917969 18 0 18.894531 0 20 C 0 21.105469 0.917969 22 2.054688 22 L 23.949219 22 C 25.082031 22 26 21.105469 26 20 C 26 18.894531 25.082031 18 23.945313 18 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 3 31.5 C 2.726563 31.5 2.5 31.277344 2.5 31 L 2.5 28.5 L 5.5 28.5 L 5.5 31 C 5.5 31.277344 5.273438 31.5 5 31.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 5 29 L 5 31 L 3 31 L 3 29 L 5 29 M 6 28 L 2 28 L 2 31 C 2 31.550781 2.449219 32 3 32 L 5 32 C 5.550781 32 6 31.550781 6 31 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 2.5 28.5 L 2.5 22.320313 L 3.457031 20.203125 L 5.480469 13.136719 C 5.757813 12.304688 6.984375 11.5 8 11.5 L 18 11.5 C 19.015625 11.5 20.242188 12.304688 20.523438 13.15625 L 22.519531 20.136719 L 23.5 22.320313 L 23.5 28.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 18 12 C 18.800781 12 19.835938 12.664063 20.039063 13.273438 L 22.039063 20.273438 L 22.058594 20.34375 L 22.089844 20.410156 L 23 22.429688 L 23 28 L 3 28 L 3 22.429688 L 3.910156 20.410156 L 3.941406 20.34375 L 3.960938 20.273438 L 5.949219 13.316406 C 6.164063 12.664063 7.199219 12 8 12 L 18 12 M 18 11 L 8 11 C 6.832031 11 5.367188 11.890625 5 13 L 3 20 L 2 22.214844 L 2 29 L 24 29 L 24 22.214844 L 23 20 L 21 13 C 20.632813 11.890625 19.167969 11 18 11 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 22 23.5 C 22 24.328125 21.328125 25 20.5 25 C 19.671875 25 19 24.328125 19 23.5 C 19 22.671875 19.671875 22 20.5 22 C 21.328125 22 22 22.671875 22 23.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 7 23.5 C 7 24.328125 6.328125 25 5.5 25 C 4.671875 25 4 24.328125 4 23.5 C 4 22.671875 4.671875 22 5.5 22 C 6.328125 22 7 22.671875 7 23.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF0FE"
    },
    d: "M 3.949219 18.5 L 5.480469 13.136719 C 5.792969 12.195313 6.675781 11.5 7.574219 11.5 L 18.425781 11.5 C 19.320313 11.5 20.207031 12.195313 20.527344 13.15625 L 22.050781 18.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 18.425781 12 C 19.101563 12 19.800781 12.566406 20.039063 13.273438 L 21.390625 18 L 4.609375 18 L 5.949219 13.316406 C 6.199219 12.566406 6.898438 12 7.574219 12 L 18.425781 12 M 18.425781 11 L 7.574219 11 C 6.40625 11 5.367188 11.890625 5 13 L 3.285156 19 L 22.714844 19 L 21 13 C 20.632813 11.890625 19.59375 11 18.425781 11 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 1.976563 19 L 24 19 L 24 21 L 1.976563 21 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF0FE"
    },
    d: "M 7.695313 28.5 L 9.1875 24.089844 C 9.304688 23.734375 9.632813 23.5 10 23.5 L 16 23.5 C 16.367188 23.5 16.695313 23.734375 16.8125 24.085938 L 18.304688 28.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 16 24 C 16.152344 24 16.289063 24.097656 16.339844 24.246094 L 17.605469 28 L 8.394531 28 L 9.660156 24.242188 C 9.710938 24.097656 9.847656 24 10 24 L 16 24 M 16 23 L 10 23 C 9.414063 23 8.898438 23.375 8.710938 23.929688 L 7 29 L 19 29 L 17.289063 23.929688 C 17.101563 23.375 16.585938 23 16 23 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M 16.054688 28.5 C 15.195313 28.5 14.5 27.828125 14.5 27 C 14.5 26.171875 15.195313 25.5 16.054688 25.5 L 37.949219 25.5 C 38.804688 25.5 39.5 26.171875 39.5 27 C 39.5 27.828125 38.804688 28.5 37.949219 28.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 37.945313 26 C 38.527344 26 39 26.449219 39 27 C 39 27.550781 38.527344 28 37.945313 28 L 16.054688 28 C 15.472656 28 15 27.550781 15 27 C 15 26.449219 15.472656 26 16.054688 26 L 37.945313 26 M 37.945313 25 L 16.054688 25 C 14.917969 25 14 25.894531 14 27 C 14 28.105469 14.917969 29 16.054688 29 L 37.949219 29 C 39.082031 29 40 28.105469 40 27 C 40 25.894531 39.082031 25 37.945313 25 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 35 38.5 C 34.726563 38.5 34.5 38.277344 34.5 38 L 34.5 35.5 L 37.5 35.5 L 37.5 38 C 37.5 38.277344 37.273438 38.5 37 38.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 37 36 L 37 38 L 35 38 L 35 36 L 37 36 M 38 35 L 34 35 L 34 38 C 34 38.550781 34.449219 39 35 39 L 37 39 C 37.550781 39 38 38.550781 38 38 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 17 38.5 C 16.726563 38.5 16.5 38.277344 16.5 38 L 16.5 35.5 L 19.5 35.5 L 19.5 38 C 19.5 38.277344 19.273438 38.5 19 38.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 19 36 L 19 38 L 17 38 L 17 36 L 19 36 M 20 35 L 16 35 L 16 38 C 16 38.550781 16.449219 39 17 39 L 19 39 C 19.550781 39 20 38.550781 20 38 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M 16.5 35.5 L 16.5 29.320313 L 17.457031 27.203125 L 19.480469 20.136719 C 19.757813 19.304688 20.984375 18.5 22 18.5 L 32 18.5 C 33.015625 18.5 34.242188 19.304688 34.523438 20.15625 L 36.519531 27.136719 L 37.5 29.320313 L 37.5 35.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 32 19 C 32.800781 19 33.835938 19.664063 34.039063 20.273438 L 36.039063 27.273438 L 36.058594 27.34375 L 36.089844 27.410156 L 37 29.429688 L 37 35 L 17 35 L 17 29.429688 L 17.910156 27.410156 L 17.941406 27.34375 L 17.960938 27.273438 L 19.949219 20.316406 C 20.164063 19.664063 21.199219 19 22 19 L 32 19 M 32 18 L 22 18 C 20.832031 18 19.367188 18.890625 19 20 L 17 27 L 16 29.214844 L 16 36 L 38 36 L 38 29.214844 L 37 27 L 35 20 C 34.632813 18.890625 33.167969 18 32 18 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 36 30.5 C 36 31.328125 35.328125 32 34.5 32 C 33.671875 32 33 31.328125 33 30.5 C 33 29.671875 33.671875 29 34.5 29 C 35.328125 29 36 29.671875 36 30.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 21 30.5 C 21 31.328125 20.328125 32 19.5 32 C 18.671875 32 18 31.328125 18 30.5 C 18 29.671875 18.671875 29 19.5 29 C 20.328125 29 21 29.671875 21 30.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF0FE"
    },
    d: "M 17.949219 25.5 L 19.480469 20.136719 C 19.792969 19.195313 20.675781 18.5 21.574219 18.5 L 32.425781 18.5 C 33.320313 18.5 34.207031 19.195313 34.527344 20.15625 L 36.050781 25.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 32.425781 19 C 33.101563 19 33.800781 19.566406 34.039063 20.273438 L 35.390625 25 L 18.609375 25 L 19.949219 20.316406 C 20.199219 19.566406 20.898438 19 21.574219 19 L 32.425781 19 M 32.425781 18 L 21.574219 18 C 20.40625 18 19.367188 18.890625 19 20 L 17.285156 26 L 36.714844 26 L 35 20 C 34.632813 18.890625 33.59375 18 32.425781 18 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98CCFD"
    },
    d: "M 15.976563 26 L 38 26 L 38 28 L 15.976563 28 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6DCFE"
    },
    d: "M 21.695313 35.5 L 23.1875 31.089844 C 23.304688 30.734375 23.632813 30.5 24 30.5 L 30 30.5 C 30.367188 30.5 30.695313 30.734375 30.8125 31.085938 L 32.304688 35.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4788C7"
    },
    d: "M 30 31 C 30.152344 31 30.289063 31.097656 30.339844 31.246094 L 31.605469 35 L 22.394531 35 L 23.660156 31.242188 C 23.710938 31.097656 23.847656 31 24 31 L 30 31 M 30 30 L 24 30 C 23.414063 30 22.898438 30.375 22.710938 30.929688 L 21 36 L 33 36 L 31.289063 30.929688 C 31.101563 30.375 30.585938 30 30 30 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCarTraffic);
export default __webpack_public_path__ + "static/media/b_car_traffic.bd6b6fea6222b8a674d2e717bebfd84c.svg";
export { ForwardRef as ReactComponent };